import {
  LMessage,
  TagValue,
  Language,
  MessageType,
  IntlMsgValues,
} from './model';
import { Languages, DefaultLanguage, AppMessages } from './const';
import Logger from '../../libs/logger';   import { LogArea } from '../../libs/logger/const';

export const newMsg = (id: string, tags: TagValue[] = []) =>
  ({ id, tags } as LMessage);

export const newTag = (tag: string, value: MessageType) =>
  ({ tag, value } as TagValue);

export const getLanguage = (langCode: string): Language =>
  Languages.find((l) => l.code === langCode || l.folder === langCode) ||
  DefaultLanguage;

const loadMessages = async (folder: string) => {
  //take it from a resource in public
  const path = `./i18n/${folder}/translations.json`
  return fetch(path)
    .then((res) => res.text())
    .then((data) => JSON.parse(data));
  //take it from a different chunk
  //return import(`./translations/${folder}/translations.json`);
};

export const getMessages = async (lang: Language) => {
  const messages = await loadMessages(lang.folder)
    .catch(() =>
      Logger.error(
        [`Translations for ${lang.name} could not be loaded`, lang],
        LogArea.Localization
      )
    );
  return { ...AppMessages, ...messages };
};

const defaultValue = (id: string) => AppMessages[id];

const messageExists = (id: string) => defaultValue(id) !== undefined;

export const isLocalizationMessage = (m: MessageType) =>
  (m as LMessage) && (m as LMessage).id;

/* eslint-disable @typescript-eslint/no-use-before-define */
const parseTags = (tags: TagValue[], t: any, reqTags: IntlMsgValues = {}) =>
  tags.reduce((p, tv) => ({ ...p, [tv.tag]: translate(tv.value, t) }), reqTags);
/* eslint-enable @typescript-eslint/no-use-before-define */

const outerCurlyBracesExpr = /\{(?:[^}{]+|\{(?:[^}{]+|\{[^}{]*\})*\})*\}/g;
const getMsgValues = (m: string) =>
  (m.match(outerCurlyBracesExpr) || [])
    .map((t: string) => t.replace('{', '').replace('}', '').split(',')[0])
    .reduce((p, val) => ({ ...p, [val]: '' }), {} as IntlMsgValues);

const parseMessage = (m: LMessage, t: any): string => {
  const { id } = m;
  if (!messageExists(id)) {
    // Logger.error(['MessageId not found', m]);
    return id;
  }
  const defaultMessage = defaultValue(id);
  const reqMsgValues = getMsgValues(defaultMessage);
  const tags = parseTags(m.tags, t, reqMsgValues);
  return t({ id, defaultMessage }, tags);
};

export const translate = (m: MessageType, formatMessage: any): string =>
  isLocalizationMessage(m)
    ? parseMessage(m as LMessage, formatMessage)
    : messageExists(String(m))
    ? parseMessage(newMsg(String(m)), formatMessage)
    : String(m);
